module.exports = __webpack_public_path__ + "static/04-d3ab469d5005bfb8209d31d23272bd25.jpg";